/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface DocumentosProps {
  base64: string | null | undefined;
  titulo: string | null | undefined;
  tipoArquivo: string | null | undefined;
}

interface Props {
  idLead365: string | null | undefined;
  documentos: DocumentosProps[];
  numeroFicha: string | null | undefined;
}

export function useVincularSimulacao(props: Props) {
  const postData = async () => {
    const VINCULAR_SIMULACAO = `${leadsWebEnviroment}/app-web/oportunidades-lead/vincular-simulacao/v1/${props?.numeroFicha}`;
    const { data } = await instance.put(VINCULAR_SIMULACAO, {
      idLead365: props.idLead365,
      documentos: props.documentos,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Simulação vinculadam com sucesso");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao vincular simulação. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
